import React, { useState } from "react";
import { Link } from "gatsby";
import cx from "classnames";
import logo from "../images/logo7_v1_final_optimised.svg";

const StyledLink = ({ className, ...props }) => {
  className = cx(className);
  return (
    <Link className={className} {...props}>
      {props.children}
    </Link>
  );
};

const HeaderLink = ({ className, children, ...props }) => {
  className = cx(
    "w-full md:w-auto py-2 md:px-1 -mb-1 sm:text-mx lg:text-xl font-medium uppercase hover:text-teal-700 relative whitespace-no-wrap",
    className
  );
  return (
    <div className="flex flex-nowrap px-1">
      <Link
        className={className}
        {...props}
        activeClassName="md:border-teal-600"
      >
        {children}
      </Link>
    </div>
  );
};

const Header = ({ className, ...props }) => {
  let [isExpanded, toggleExpansion] = useState(false);

  className = cx("w-full bg-white ", className);
  return (
    <div className={className} {...props}>
      <div className="flex flex-row items-start md:items-center justify-between px-6 md:px-8 lg:px-24 text-teal-800">
        <div className="my-3">
          <Link to="/">
            <img className="w-3/5" alt="Angela Cooney - Executive Coach" src={logo} />
          </Link>
        </div>

        <button
          className="block relative md:hidden border border-teal-800 my-4 px-3 py-2"
          onClick={() => toggleExpansion(!isExpanded)}
        >
          <svg
            className="fill-current h-4 w-4"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>

        <div
          className={`${
            isExpanded ? `block` : `hidden`
          } w-full md:w-auto flex md:flex flex-col md:flex-row justify-center md:justify-end items-stretch md:items-center py-1`}
        >
          <HeaderLink to="/about">About Me</HeaderLink>
          <HeaderLink to="/services">Services</HeaderLink>
          <HeaderLink to="/coaching">Coaching</HeaderLink>
          <HeaderLink to="/contact">Get in Contact</HeaderLink>

        </div>
      </div>
    </div>
  );
};

export default Header;
